import React, { useEffect, useMemo } from 'react';
import { translate } from '../../Services/translation';
import QuickSearchNoHit from './QuickSearch.NoHit';
import QuickSearchResultTab from './QuickSearchResultTab';
import QuickSearchResultTabItem from './utils/QuickSearchResult.TabItem';
import { QuickSearchResultItem } from '../../Types/QuickSearchResultItem';
import { EditorStringModel } from '../../Types/EditorString';
import clsx from 'clsx';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import { setNavisionListingPricesQuickSearch } from '../../Actions/NavisionPrices.action';
import { setNavisionListingstocksQuickSearch } from '../../Actions/NavisionStock.action';

interface QuickSearchResultProps extends PriceStateBaseModel {
  result: { results: QuickSearchResultItem[] };
  searchUrl: string;
  activeTab?: string;
  noHitHeader: string;
  noHitDescription: EditorStringModel;
}

const QuickSearchResult = ({
  result,
  searchUrl,
  activeTab,
  noHitHeader,
  noHitDescription,
  showBothPrices,
  currentPriceToggleType,
}: QuickSearchResultProps) => {
  const items = useMemo(() => result?.results, [result]);
  const totalNumResults = useMemo(
    () =>
      items?.reduce((total, curr) => curr.items.length + total, 0) ?? 0,
    [items]
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchstocks = async () => {
      var products = items?.find(
        (resultItem) => resultItem.key === 'products'
      );
      const productIds = products?.items?.map((p) => {
        return p?.id;
      });
      if (productIds && productIds.length > 0) {
        dispatch(setNavisionListingstocksQuickSearch(productIds));
      }
    };

    const fetchPrices = async () => {
      var products = items?.find(
        (resultItem) => resultItem.key === 'products'
      );
      const productIds = products?.items?.map((p) => {
        return p?.id;
      });
      if (productIds && productIds.length > 0) {
        dispatch(setNavisionListingPricesQuickSearch(productIds));
      }
    };

    if (currentPriceToggleType != null) {
      fetchstocks();
    }

    if (showBothPrices) {
      fetchPrices();
    }
  }, [items]);

  const { navisionPrices, navisionStocks } = useTypedSelector(
    (state) => state.quickSearch
  );

  return (
    <div
      className={clsx(
        'absolute',
        'top-28',
        'left-0',
        'right-0',
        'px-4',
        'bg-white',
        'border',
        'border-solid',
        'border-gray-300',
        'z-[55]',
        'lg:top-12',
        'lg:w-max',
        'lg:min-w-[50vw]',
        totalNumResults > 0 && 'lg:h-96'
      )}
    >
      {totalNumResults > 0 && (
        <div>
          <ul className="-mr-4 flex list-none gap-4 overflow-y-auto pr-4 pt-4 scrollbar-none">
            {items?.map(
              (item, idx) =>
                item.items.length > 0 && (
                  <QuickSearchResultTabItem
                    resultKey={item.key}
                    active={item.key == activeTab}
                    quantity={item.items.length}
                    key={idx}
                  />
                )
            )}
          </ul>
        </div>
      )}
      {totalNumResults > 0 &&
        items?.map(
          (item, idx) =>
            item.items.length > 0 &&
            item.key == activeTab && (
              <QuickSearchResultTab
                modelKey={item.key}
                results={item.items}
                key={idx}
                showBothPrices={showBothPrices}
                navisionPrices={navisionPrices}
                navisionStocks={navisionStocks}
              />
            )
        )}
      {totalNumResults == 0 && (
        <QuickSearchNoHit
          title={noHitHeader}
          description={noHitDescription}
        />
      )}
      {totalNumResults > 0 && (
        <div className="fixed -left-4 bottom-0 ml-4 flex h-16 w-full items-center justify-center border-t border-solid border-gray-300 bg-white px-4 py-2 lg:absolute lg:bottom-0 lg:left-0 lg:ml-0">
          <a
            href={searchUrl}
            className="btn btn--secondary btn--large w-full "
          >
            {translate('quicksearch.showmore')}
          </a>
        </div>
      )}
    </div>
  );
};

export default QuickSearchResult;
